import { Location } from '@angular/common';
import { Component, EventEmitter, HostBinding, inject, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'kh-back-button',
  standalone: true,
  imports: [TranslateModule],
  styleUrls: ['./back-button.component.less'],
  templateUrl: './back-button.component.html'
})
export class BackButtonComponent {
  @Input() public textColor: string | undefined;
  @Output() public clickEvent = new EventEmitter<void>();

  private readonly location = inject(Location);

  @HostBinding('style.--kh-back-button-color')
  public get cssTextColor(): string | undefined {
    return this.textColor;
  }

  public handleClick(): void {
    if (this.clickEvent.observed) {
      this.clickEvent.emit();
    } else {
      this.location.back();
    }
  }
}
